(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

(function () {
    // Set constant names.
    var FORCE_CLEAN_DATE_KEY = "cookieForceCleanDate";
    var LAST_CLEAN_TIMESTAMP_KEY = "cookieLastClean";
    var CLEAN_DONE_FLAG_KEY = "cookieCleanDone";

    // Current clean date (editable) - must be in YYYY-MM-DD format.
    var CURRENT_FORCE_CLEAN_DATE = "2025-11-19";
    var forceCleanTimestamp = new Date(CURRENT_FORCE_CLEAN_DATE).getTime();

    var storedLastCleanTS = parseInt(localStorage.getItem(LAST_CLEAN_TIMESTAMP_KEY) || "0", 10);
    var cleanDone = localStorage.getItem(CLEAN_DONE_FLAG_KEY) === "true";

    // Determine whether a forced clean must be performed.
    var mustForceClean = !cleanDone || storedLastCleanTS < forceCleanTimestamp;

    if (mustForceClean) {
        /**
         * This method deletes all cookies accessible from the current domain.
         */

        var deleteAllCookies = function deleteAllCookies() {
            var cookies = document.cookie.split(";");

            cookies.forEach(function (cookie) {
                var eqPos = cookie.indexOf("=");
                var name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

                // Delete cookie on current domain.
                document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";

                // Delete cookies on parent domains.
                var domainParts = window.location.hostname.split(".");
                while (domainParts.length > 0) {
                    var domain = domainParts.join(".");
                    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + domain;
                    domainParts.shift();
                }
            });
        };

        deleteAllCookies();

        // Save control information.
        localStorage.setItem(FORCE_CLEAN_DATE_KEY, CURRENT_FORCE_CLEAN_DATE);
        localStorage.setItem(LAST_CLEAN_TIMESTAMP_KEY, Date.now().toString());
        localStorage.setItem(CLEAN_DONE_FLAG_KEY, "true");
    }
})();

},{}]},{},[1]);
